const PathConstants = {
    DASHBOARD: "/",
    TEAM: "/team",
    TEAM_ADD: "/team/add",
    TEAM_EDIT: "/team/edit/",
    TENANT_ADD: "/tenant/add",
    SETTINGS: "/settings",
    CUSTOMERS: "/customers",
    CUSTOMER_ADD: "/customers/add",
    CUSTOMER_EDIT: "/customers/edit/"
    
}

export default PathConstants